import { useEffect, useCallback } from 'react';

import { sendBreakdownButtonClickedEvent } from 'components/Core/Invoice/BreakdownSection/utils/breakdownAnalytics';
import { getDisplayableLineItemsCount } from 'components/Core/Invoice/utils/lineItemsValidationHelper';
import { useIsMobileScreen } from 'hooks/useIsMobile';
import SegmentIO from 'reporting/SegmentIO';
import { LineItem } from 'types/Sale';

export type { BreakdownAnalyticsActionType } from 'components/Core/Invoice/BreakdownSection/utils/breakdownAnalytics';

interface UseInvoiceBreakdownAnalyticsProps {
  isExpanded: boolean;
  invoiceLineItems?: LineItem[];
  onToggle: () => void;
}

export const useInvoiceBreakdownAnalytics = ({
  isExpanded,
  invoiceLineItems,
  onToggle,
}: UseInvoiceBreakdownAnalyticsProps) => {
  const isMobile = useIsMobileScreen();
  const sendBreakdownButtonViewedEvent = useCallback(() => {
    // @ts-ignore
    SegmentIO.transactionViewed({
      object: 'transaction',
      action: 'viewed',
      ui_object: 'button',
      ui_object_detail: 'invoice_breakdown_button',
      ui_action: 'loaded',
      ui_access_point: 'transaction_flow',
    });
  }, []);

  useEffect(() => {
    sendBreakdownButtonViewedEvent();
  }, [sendBreakdownButtonViewedEvent]);

  const handleToggleWithAnalytics = useCallback(() => {
    const displayedLineItemsCount = getDisplayableLineItemsCount(invoiceLineItems);

    sendBreakdownButtonClickedEvent(
      isExpanded ? 'collapsed' : 'expanded',
      displayedLineItemsCount,
      isMobile
    );

    onToggle();
  }, [isExpanded, invoiceLineItems, onToggle, isMobile]);

  return {
    handleToggleWithAnalytics,
  };
};
